import { createSelector } from 'reselect';

export const selectLocation = (state) => state.router.location;

export const selectState = createSelector(selectLocation, (location) =>
  location && location.state && location.state.warningModal ? location.state.warningModal : {},
);

export const warningModalSelectors = {
  selectState,
};
